import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { IResponse } from '../shared/models/IResponse.model';
import { ToastService } from './toast.service';
import { IProcessesModel } from '../shared/models/processes.model';

@Injectable({
  providedIn: 'root'
})
export class ProcessesService {

  constructor(private httpClient: HttpClient, private toastService: ToastService) { }

  getProcesses(filter: Partial<IProcessesModel> = { isActive: true }): Observable<IProcessesModel[]> {
    return this.httpClient.post(`${environment.api_base_url}processes/search`, filter, {}).pipe(
      map((item: IResponse<IProcessesModel[]>) => {
        if(item?.isError){
          console.log(item.message);
        }
        return item?.data || [];
      }),
      catchError((error) => {
        console.log(error);
        return of([]);
      })
    );
  }
}
